var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeatballMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 3,
    viewBox: "0 0 16 3",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 3C8.39782 3 8.77936 2.84196 9.06066 2.56066C9.34196 2.27936 9.5 1.89782 9.5 1.5C9.5 1.10218 9.34196 0.720644 9.06066 0.43934C8.77936 0.158035 8.39782 0 8 0C7.60218 0 7.22064 0.158035 6.93934 0.43934C6.65804 0.720644 6.5 1.10218 6.5 1.5C6.5 1.89782 6.65804 2.27936 6.93934 2.56066C7.22064 2.84196 7.60218 3 8 3ZM1.5 3C1.89782 3 2.27936 2.84196 2.56066 2.56066C2.84196 2.27936 3 1.89782 3 1.5C3 1.10218 2.84196 0.720644 2.56066 0.43934C2.27936 0.158035 1.89782 0 1.5 0C1.10218 0 0.720644 0.158035 0.43934 0.43934C0.158035 0.720644 0 1.10218 0 1.5C0 1.89782 0.158035 2.27936 0.43934 2.56066C0.720644 2.84196 1.10218 3 1.5 3ZM14.5 3C14.8978 3 15.2794 2.84196 15.5607 2.56066C15.842 2.27936 16 1.89782 16 1.5C16 1.10218 15.842 0.720644 15.5607 0.43934C15.2794 0.158035 14.8978 0 14.5 0C14.1022 0 13.7206 0.158035 13.4393 0.43934C13.158 0.720644 13 1.10218 13 1.5C13 1.89782 13.158 2.27936 13.4393 2.56066C13.7206 2.84196 14.1022 3 14.5 3Z",
    fill: "#1B1B1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeatballMenu);
export default __webpack_public_path__ + "static/media/meatball-menu.651eae3ec88134f7632d24a3604252b8.svg";
export { ForwardRef as ReactComponent };